interface Timeline {
  id: string;
  label: string;
  description: string;
}

interface TimelineSelectorProps {
  selectedTimeline: string;
  onSelect: (timelineId: string) => void;
}

const TimelineSelector = ({ selectedTimeline, onSelect }: TimelineSelectorProps) => {
  const timelines: Timeline[] = [
    { id: 'urgent', label: 'Urgent', description: 'Moins de 1 mois' },
    { id: 'short', label: 'Court terme', description: '1-3 mois' },
    { id: 'medium', label: 'Moyen terme', description: '3-6 mois' },
    { id: 'flexible', label: 'Flexible', description: 'Plus de 6 mois' },
  ];

  return (
    <div data-component-id="src/app/contact-quote/components/TimelineSelector.tsx:21:4" data-component-path="src/app/contact-quote/components/TimelineSelector.tsx" data-component-line="21" data-component-end-line="37" data-component-file="TimelineSelector.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20md%3Agrid-cols-2%20gap-4%22%7D" className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {timelines.map((timeline) => (
        <button data-component-id="src/app/contact-quote/components/TimelineSelector.tsx:23:8" data-component-path="src/app/contact-quote/components/TimelineSelector.tsx" data-component-line="23" data-component-end-line="35" data-component-file="TimelineSelector.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22button%22%7D"
          key={timeline.id}
          type="button"
          onClick={() => onSelect(timeline.id)}
          className={`p-6 rounded-lg border-2 transition-all duration-300 text-center ${
            selectedTimeline === timeline.id
              ? 'border-primary bg-light-accent shadow-gold'
              : 'border-border bg-card hover:border-primary-light hover:shadow-subtle'
          }`}
        >
          <h3 data-component-id="src/app/contact-quote/components/TimelineSelector.tsx:33:10" data-component-path="src/app/contact-quote/components/TimelineSelector.tsx" data-component-line="33" data-component-end-line="33" data-component-file="TimelineSelector.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22font-playfair%20font-bold%20text-lg%20text-text-primary%20mb-2%22%7D" className="font-playfair font-bold text-lg text-text-primary mb-2">{timeline.label}</h3>
          <p data-component-id="src/app/contact-quote/components/TimelineSelector.tsx:34:10" data-component-path="src/app/contact-quote/components/TimelineSelector.tsx" data-component-line="34" data-component-end-line="34" data-component-file="TimelineSelector.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-text-secondary%22%7D" className="text-sm text-text-secondary">{timeline.description}</p>
        </button>
      ))}
    </div>
  );
};

export default TimelineSelector;